import {CloseIcon} from "./library/close.icon";
import {PokerBrandSmallIcon} from "./library/poker-brand-small.icon";
import {SportBrandSmallIcon} from "./library/sport-brand-small.icon";
import {CasinoBrandSmallIcon} from "./library/casino-brand-small.icon";

export const Icons = {
  Close: CloseIcon,
  PokerBrandSmall: PokerBrandSmallIcon,
  SportBrandSmall: SportBrandSmallIcon,
  CasinoBrandSmall: CasinoBrandSmallIcon
};
